'use client';

import { useParams, usePathname } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client/react';
import { eventLayoutQuery } from '@/apollo/events';
import { extractId } from '@/utils/slugify';
import Main from '@/components/main';
import EventHeader from '@/components/events/header';

type Props = {
  children: React.ReactNode;
};

const EventLayoutClient = ({ children }: Props) => {
  const { id: rawId } = useParams();
  const id = extractId(rawId as string);
  const pathname = usePathname();
  const { data } = useSuspenseQuery(eventLayoutQuery, {
    variables: { id },
  });

  const isEdit = pathname.includes('/edit');
  const noTabs = isEdit || pathname.includes('/attendees') || pathname.includes('/settings');

  return (
    <Main compact>
      <EventHeader event={data.event} tab="overview" noTabs={noTabs} hideDraftAlert={isEdit} />
      {children}
    </Main>
  );
};

export default EventLayoutClient;
